<template>
    <modal  title="" :showTitle="false" :showModal="showModal" @close-modal="closeModal">
        <div>
            <div class="flex item-center justify-between mb-4">
                <span class="text-xl font-[500]"> Select a Shipping Service</span>
                <span class="cancle_btn" @click="closeModal">
                    &#x2715;
                </span>
            </div>
            <div class="info_notify">
                <img src="@/assets/images/bulb.svg" class="inline mr-2" />
                <span>This price covers only terminal-to-terminal shipping. The full shipping cost will appear on the Summary page.</span>
            </div>
            <p class="text-sm font-[500] mb-4 text-primary-yellow">
                Based on the size of your shipment, the following shipping services are available.
            </p>

            <!-- start of filter -->
            <div class="flex flex-wrap px-0 options_filter border-dashed border-gray-500 pb-2 sorter_option rounded-md md:justify-between"
                v-if="!loading">
                <div :style="{ width: '25%' }" class="pt-2">
                    <el-select placeholder="sort by carrier" v-model="carrierSort" class="[&>div>input]:border-none">
                        <el-option v-for="(service, index) in sortByCarier" :label="service.label"
                            :value="service.value" :key="index + 'carrier'"></el-option>
                    </el-select>
                </div>
                <div :style="{
                    marginTop: '10px',
                    border: '1px dashed #4142455C',
                    position: 'relative',
                    top: '5px',
                }" class="h-6"></div>

                <div :style="{ width: '24%' }" class="pt-2">
                    <el-select placeholder="sort by Vehicle type" v-model="vehicleSort"
                        class="[&_.el-input__inner]:border-none">

                    </el-select>
                </div>

                <div :style="{
                    marginTop: '10px',
                    border: '1px dashed #4142455C',
                    position: 'relative',
                    top: '5px',
                }" class="h-6"></div>

                <div :style="{ width: '25%' }" class="pt-2">
                    <el-select placeholder="sort by cost" v-model="costSort" class="[&_.el-input__inner]:border-none">
                        <el-option label="0 - 10,000" :value="[0, 10000]"></el-option>
                        <el-option label="10,000 - 50,000" :value="[10000, 50000]"></el-option>
                        <el-option label="50,000 - 100,000" :value="[50000, 100000]"></el-option>
                        <el-option label="100,000 - 500,000" :value="[100000, 500000]"></el-option>
                        <el-option label="500,000 - 10,000,000" :value="[100000, 500000]"></el-option>
                    </el-select>
                </div>

                <div :style="{ width: '24%' }" class="pt-2">
                    <el-select placeholder="sort by Availablitiy" v-model="availableSort"
                        class="[&_.el-input__inner]:border-none">

                    </el-select>
                </div>
            </div>
            <!-- end of filter -->


            <div>
                <div class="flex py-24 bg-gray-200 flex-wrap mt-3 w-full h-full z-10" v-if="loading">
                    <div class="w-full flex justify-center">
                        <span class="loader">
                            <img src="@/assets/images/ondemand/loader.svg" /></span>
                    </div>
                </div>
                <div class="w-full pb-10 flex flex-wrap my-4" v-else>
                    <label class="label w-full">Select Shipping Service</label>
                    <div v-if="shippingServiceLoading" class="grid h-64 w-full place-items-center">
                        <span class="loader">
                            <img src="@/assets/images/ondemand/loader.svg" /></span>
                    </div>
                    <div class="w-full overflow-x-auto">
                        <div v-if="!shippingServiceLoading" class="service_container">
                            <div v-for="(item, index) in filteredShippingService" class="mr-2 my-2 zoom cursor-pointer"
                                :key="index + 'shipping_service'" @click="setShippingService(item, item)"
                                :class="[selectedShippingService == item.id && deliveryClass == item?.costData?.costType ? 'active-tab' : 'dull-tab']">
                                <p class="opacity-75 font-semibold flex justify-center flex-wrap items-center mb-2">
                                    <span class="flex justify-center text-primary-yellow w-full items-center py-1 ">
                                        <img :src="item.org && item.org.imageurl ? item.org.imageurl : ''"
                                            class="mr-2 rounded-full w-6 h-6 bg-primary-navy" />{{ item.orgName }}
                                    </span>
                                    <!-- <span
                                        class="block w-full mt-2 pb-2 border-b-[1px] border-gray-400 text-black font-normal text-sm">
                                        30 Tonne Truck (Open Body)
                                    </span> -->
                                </p>
                                <!-- <p class="text-sm uppercase">
                                {{ item.costData ? item.costData.costTye : "--" }}
                            </p> -->
                                <p class="py-1">
                                    <b class="big-text"><sup>₦</sup>
                                        {{ amountFomatter(item.costData.totalCost || 0) }}</b>
                                </p>
                                <p class="opacity-50 py-1 pb-2 mb-2 text-sm border-b-[1px] border-gray-400">
                                    Two-Way Total
                                </p>
                                <p>
                                    In {{ item.arrival && item.arrival.locationName ? item.arrival.locationName : "N/A"
                                    }}
                                </p>
                                <p class="mt-1 opacity-50">
                                    Arrives {{ item.arrivalTime || "N/A" }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="text-base text-red-600 w-full justify-center flex py-8"
                        v-if="!shippingServiceLoading && !filteredShippingService.length">
                        <b>No Fleet Available, for the selected locations</b>
                    </div>
                </div>
            </div>

            <div class="flex justify-end pt-12">
                <base-button text="Cancel" background="bg-white" border="border border-darkBlue" @click="closeModal" />
                <div class="mx-2"></div>
                <base-button text="Continue" :loading="loading" @click="useShippingService" />
            </div>
        </div>
    </modal>
</template>

<script>
import { onbordingtype } from "@/components/constant/onboardingType.js";
export default {
    name: 'TruckShippingservice',
    data() {
        return {
            isAddress: false,
            orgnameFilter: "",
            categoryFilter: "",
            costFilter: "",
            carrierSort: "",
            vehicleSort: "",
            availableSort: "",
            costSort: [],
            is3Pl: false,
            selectedShippingService: null,
            shippingServiceLoading: false,
            shippingservices: [],
            loading: false,
            deliveryClass: undefined,
            sender: {
                address: {
                    name: null
                }
            }
        }
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        bookingId: {
            type: String,
            required: false,
        },
        createdBooking: {
            required: false
        }
    },
    watch: {
        showModal(val) {
            this.is3Pl = this.$store.getters.user.onboardingtype.toLowerCase() == onbordingtype.MULEEX_3PL;
            if (val) {
                this.getShippingService()
            }
        }
    },
    computed: {
        sortByVehicle() {
            return (this.shippingservices || []).map((item) => {
                return { label: item?.orgName, value: item?.orgName }
            })
        },
        sortByCarier() {
            let carierArray = (this.shippingservices || []).map(item => ({
                label: item?.orgName,
                value: item?.orgName
            }));

            const carierArraySet = Array.from(
                new Set(carierArray.map(item => item.value))
            ).map(name => ({
                label: name,
                value: name
            }));

            return carierArraySet
        },
        filteredShippingService() {
            return this.shippingservices.filter((service) => {
                const hasCarrier = this.carrierSort && this.carrierSort.trim() !== "";
                const hasCost = Array.isArray(this.costSort) && this.costSort.length === 2;

                // If neither filter is active, return all
                if (!hasCarrier && !hasCost) return true;

                const matchesCarrier = hasCarrier
                    ? service.orgName === this.carrierSort
                    : true;

                const matchesCost = hasCost
                    ? service.costData?.totalCost > this.costSort[0] &&
                    service.costData?.totalCost < this.costSort[1]
                    : true;

                return matchesCarrier && matchesCost;
            });

        },
        customStyle() {
            return {
                width: '100%',
                padding: '7px 10px',
                borderRadius: '5px',
                border: '1px solid rgb(183 189 205)'
            }
        },
        payload() {
            return {
                shipperLocationId: this.createdBooking?.shipperLocationId,
                shippingId: this.createdBooking.id,
                shipmentType: "single",
                terminalType: this.$store.getters.getNewBookingShippingMethod,
                orgId: this.is3Pl ? this.$store.getters.user.orgId : undefined,
                userType: this.createdBooking?.user?.accounttype,
            }
        }
    },
    methods: {
        useShippingService() {
            this.$emit("updateBookinWithShippingService", this.selectedShippingService, this.deliveryClass)
        },
        async getShippingService() {
            this.loading = true;
            try {
                let response = await this.$_getShippingService(this.payload);
                this.shippingservices = response.data.data.shippingServices;

            } catch (error) {
                // ..error code here
            } finally {
                this.loading = false;
            }
        },
        setShippingService(item, shipping) {
            this.selectedShippingService = item?.id;
            this.$store.dispatch("setActiveShippingService", item);
            this.deliveryClass = shipping?.costData?.costType;
        },
        closeModal() {
            this.$emit("close-modal");
        },
    }
}
</script>

<style lang="scss" scoped>
.service_container {
    @apply overflow-x-auto whitespace-nowrap flex
}

.dull-tab {
    @apply p-2 border-2 border-gray-400 bg-gray-100 text-center py-8 duration-300 px-4;
    width: 250px;
}

.active-tab {
    width: 250px;
    @apply p-2 border-2 border-gray-400 bg-primary-navy text-white text-center py-8 duration-300 px-4;
}

.cancle_btn {
    @apply w-[20px] h-[20px] rounded-full border-[1px] border-red-400 text-red-400 inline-flex justify-center items-center text-[13px] cursor-pointer
}

.big-text {
    @apply text-2xl font-[600]
}

:deep(.el-select .el-input__inner) {
    border: none !important;
    box-shadow: none !important;
}

.loader {
    display: inline-block;
    width: auto;
    height: auto;
    animation: 2s infinite linear rolls;
}

@keyframes rolls {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
.info_notify{
    @apply bg-primary-palegrey/30 border border-primary-palegrey rounded-lg flex gap-1 px-3 items-center text-sm py-2 mb-4
}
</style>